import http from '../http'

export default {
  // 举报
  report(data: object) {
    return http.post('/report', data);
  },
  // 获取国家列表
  getCountryList() {
    return http.get('/country');
  },
  // 获取对应分区国家列表
  getRegionCountryList() {
    return http.get('/region/country');
  },
  // 获取上传文件地址
  getUploadUrl(data: object) {
    return http.put('/presign/url', data)
  },
  // 上传文件，注意：data必须为formData对象，包含file和filePathName两个属性，上传文件请直接使用src/utils/common.ts中的uploadFile方法
  uploadFile(url: string, data: object) {
    return http.put(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'noAuthorization': true, // 不需要授权
      },
    });
  },
  // 获取配置
  getSettings() {
    return http.get('/settings');
  },
  // 获取钱包余额
  getBalance() {
    return http.get('/wallet/balance');
  },
  // 获取用户基础信息
  getUserInfo(duid: string) {
    return http.get('/user/' + duid);
  }
}
